import { useAppContext } from '@Containers/AppContainer';
import { setLoggedIn, useSessionContext } from '@Containers/SessionContainer';
import Axios from '@Core/Axios';
import Gql from '@Core/Gql';
import Hook from '@Core/Hook';
import User, { UserInterface } from '@Modules/User/User';
import gql from 'graphql-tag';
import React, { ReactNode, useEffect } from 'react';

const GQL_INIT_QUERY = gql`
    {
        init {
            loggedIn
            user
            version
        }
    }
`;

type InitDataInterface = {
    loggedIn: boolean;
    user: UserInterface|null;
    version: string|null;
};

let initData: InitDataInterface;
let iniatialized = false;

export async function init() {
    await Axios.get(`/sanctum/csrf-cookie`);

    const response = await Gql('core')
        .request<{init: InitDataInterface}>(GQL_INIT_QUERY);

    initData = response.init;

    setLoggedIn(initData.loggedIn);

    iniatialized = true;

    Hook.run('iniatialized');
}

export async function isInitialized() {
    return new Promise((resolve) => {
        if (iniatialized) {
            resolve(iniatialized);

            return;
        }

        Hook.subscribe('iniatialized', () => resolve(iniatialized));
    });
}

export default function InitContainer({ children }: { children: ReactNode }) {
    const { setLoading, setVersion } = useAppContext();
    const { setUser } = useSessionContext();

    useEffect(() => {
        (async () => {
            await isInitialized();

            if (initData.loggedIn && initData.user) {
                setUser(new User(initData.user));
            }

            setLoading(false);
            setVersion(initData.version);
        })();
    }, []);

    return <>{children}</>;
}
